<template>
  <div>
    <div class="mt-2 mb-4">
      <div class="row d-flex justify-content-end">
        <div class="col-md-3 col-lg-6 text-right">
          <button
            type="button"
            class="btn btn-custom-primary"
            @click.prevent="addChantier()"
          >
            <i class="fas fa-plus"></i>
            Ajouter chantier
          </button>

          <button
            type="button"
            class="btn btn-danger ml-4"
            @click.prevent="deleteAllSelection"
            v-show="isSelect"
          >
            <i class="fas fa-trash"></i>
            Supprimer
          </button>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-12">
          <DataTable
            v-if="
              id &&
              currentRemplacement.header &&
              !currentRemplacement.header.all_chantiers
            "
            :id="id"
            ref="datatable"
            @onSelect="onSelectRows"
            @onRowsDelete="deleteRows"
            :headers="selectedHeaders"
          />

          <h4 class="bg-white p-4 text-center" v-else>Tous les chantiers</h4>
        </div>
      </div>
    </div>

    <MyModal
      ref="myModal"
      :propForm="form"
      :modalID="modalName"
      :modalTitle="titleModal"
      :chantiers="chantiers"
      :selectedChants="selectedChants"
      @submit="submitForm"
      @closeModal="closeModal"
    />
  </div>
</template>

<script>
import DataTable from '../components/DataTable.vue';
import URL from '@/http/remplacement';
import MyModal from '../components/AddChantierModal.vue';
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';

import From from 'vform';

export default {
  data() {
    return {
      form: new From({
        all: false,
      }),
      chantiers: [],
      selectedChants: [],

      titleModal: 'Ajout de chantiers',
      modalName: 'modal-chantier',
      showModal: false,

      id: null,
      isSelect: false,
      selectedTiersTypes: null,
      selectedHeaders: [],
      tiersTypes: [],
      headers: [
        {
          text: 'Nom',
          align: 'start',
          sortable: true,
          value: 'nom',
        },
        {
          text: 'Code chantier',
          align: 'start',
          sortable: false,
          value: 'code_chantier',
        },
        {
          text: 'Client',
          align: 'start',
          sortable: false,
          value: 'client',
        },
        {
          text: 'Société',
          align: 'start',
          sortable: false,
          value: 'societe',
        },
        {
          text: 'Action',
          align: 'center',
          sortable: false,
          value: 'id',
        },
      ],
    };
  },
  created() {
    this.selectedHeaders = this.headers;
  },
  watch: {
    selectedHeaders() {
      this.selectedHeaders =
        this.selectedHeaders.length === 0 ? this.headers : this.selectedHeaders;
    },
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  components: {
    DataTable,
    MyModal,
  },
  methods: {
    ...mapActions('remplacement', ['setCurrentRemplacement']),
    async addChantier() {
      await window.axios
        .get(URL.GET_CHANTIER_REQUIREMENTS(this.id))
        .then((resp) => {
          this.chantiers = resp.data.chantiers;
        });

      await this.$bvModal.show(this.modalName);
    },
    updateSelect(values) {
      let ids = values.map((a) => a.id);
      this.$refs.datatable.setFilter(ids);
      this.$refs.datatable.loadItems();
    },
    onSelectRows(isSelect) {
      this.isSelect = isSelect;
    },
    deleteAllSelection() {
      this.deleteRows(this.$refs.datatable.idsRowsSelected);
    },
    deleteRows(ids) {
      if (ids && ids.length > 0) {
        let msg = ids.length > 1 ? 'ces chantiers' : 'ce chantier';
        this.showConfirmDelete(
          'Voulez-vous vraiment retirer ' + msg + '?'
        ).then((result) => {
          if (result.value) {
            window.axios
              .delete(URL.GET_CHANTIERS(this.id), {
                params: {
                  ids: ids,
                },
              })
              .then((resp) => {
                this.showSimpleAlerte('top-end', 'success', resp.data.message);
                this.$refs.datatable.loadItems();
                this.isSelect = false;
              })
              .catch();
          }
        });
      }
    },

    submitForm(form) {
      form
        .post(URL.GET_CHANTIERS(this.id))
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          form.reset();
          form.clear();
          this.$bvModal.hide(this.modalName);
          this.setCurrentRemplacement(resp.data.remplacement);
          this.$refs.myModal.reset();

          if (
            this.currentRemplacement &&
            !this.currentRemplacement.header.all_chantiers
          ) {
            try {
              this.$refs.datatable.loadItems();
            } catch (err) {
              return err;
            }
          }
        })
        .catch((err) => {
          form.errors.set('message', err.response.data.message);
          this.$bvModal.show(this.modalName);
        })
        .finally(() => {
          this.form = form;
        });
    },

    closeModal() {
      this.form.reset();
      this.form.clear();
    },
  },
  computed: {
    ...mapGetters('remplacement', ['currentRemplacement']),
  },
  mounted() {
    this.id = this.$route.params.id;
  },
};
</script>

<style scoped></style>
